// extracted by mini-css-extract-plugin
export default {"wrapper":"PeopleList_wrapper__dJg0g"};